module.exports = __webpack_public_path__ + "img/sunset.84106596.svg";